import * as types from "../actions/types";

const initialState = {
  list: null,
  params: null,
  loading: false,
  teachers: [],
  courses: [],
  weeks: [],
  lesson: null,
  eventTypes: [],
  weights: [],
  themes: [],
  trials: [],
  modalLoading: false
};

export default function planning(state = initialState, action) {
  switch (action.type) {
    case types.GET_THEME_PLANNING:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_THEME_PLANNING_LOAD:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_THEME_PLANNING_TEACHERS:
      return {
        ...state,
        teachers: action.payload
      };
    case types.SET_THEME_PLANNING_COURSES:
      return {
        ...state,
        courses: action.payload
      };
    case types.SET_THEME_PLANNING_WEEKS:
      return {
        ...state,
        weeks: action.payload
      };
    case types.SET_THEME_PLANNING_LESSON:
      return {
        ...state,
        lesson: action.payload
      };
    case types.SET_THEME_PLANNING_EVENT_TYPES:
      return {
        ...state,
        eventTypes: action.payload
      };
    case types.SET_THEME_PLANNING_WEIGHTS:
      return {
        ...state,
        weights: action.payload
      };
    case types.SET_THEME_PLANNING_THEMES:
      return {
        ...state,
        themes: action.payload
      };
    case types.SET_THEME_PLANNING_TRIALS:
      return {
        ...state,
        trials: action.payload
      };
    case types.SET_THEME_PLANNING_MODAL_LOAD:
      return {
        ...state,
        modalLoading: action.payload
      };
    case types.CLEAR_THEME_PLANNING_LESSON:
      return {
        ...state,
        lesson: null,
        themes: [],
        trials: []
      };
    case types.CLEAR_THEME_PLANNING:
      return {
        ...state,
        list: null,
        teachers: [],
        courses: []
      };
    default:
      return state;
  }
}
